import React, { useState, useEffect } from "react";
import Sidebar from "../Sidebar";

const Loader = () => {
  const aiMessages = [
    "Gathering your career details…",
    "Evaluating your job profile…",
    "Analyzing job impact and exposure…",
    "Assessing task automation risk…",
    "Mapping emerging career opportunities…",
    "Exploring complementary career pathways…",
    "Compiling personalized career recommendations…",
    "Finalizing your career insights…",
  ];

  const [currentMessage, setCurrentMessage] = useState(aiMessages[0]);

  useEffect(() => {
    const messageInterval = setInterval(() => {
      setCurrentMessage((prevMessage) => {
        const currentIndex = aiMessages.indexOf(prevMessage);
        const nextIndex = (currentIndex + 1) % aiMessages.length;
        return aiMessages[nextIndex];
      });
    }, 2000);

    return () => clearInterval(messageInterval);
  }, []);

  const LoaderContent = () => (
    <div className="flex flex-col w-full min-h-screen bg-white pt-20">
      <div className="flex flex-col items-center justify-center w-full h-64 p-6 space-y-8">
        <div className="relative w-16 h-16">
          <div className="absolute inset-0 rounded-full bg-purple-500 opacity-30 animate-ping"></div>

          <div className="absolute inset-0 flex items-center justify-center rounded-full bg-purple-600">
            <div className="w-8 h-8 rounded-full border-4 border-purple-200 border-t-purple-50 animate-spin"></div>
          </div>
        </div>

        <div className="h-8 text-center">
          <div className="text-gray-700 font-medium min-w-64 px-4">
            <span className="inline-block transition-opacity duration-500 ease-in-out">
              {currentMessage}
            </span>
          </div>
        </div>

        <div className="flex items-center text-gray-700">
          <span className="ml-2 w-6">
            <span className="inline-block animate-bounce">.</span>
            <span className="inline-block animate-bounce delay-75">.</span>
            <span className="inline-block animate-bounce delay-150">.</span>
          </span>
        </div>
      </div>
    </div>
  );

  return (
    <Sidebar>
      <LoaderContent />
    </Sidebar>
  );
};

export default Loader;
